export default "__VITE_ASSET__Bf0fgst___"